import { FC } from "react";
import { Modal } from "../../layout/Modal";
import { GifSearch } from "./GifSearch";

export const GifModal: FC<{
	closeModal: () => void;
	onGifClick: (gifId: string, searchTerm: string) => void;
}> = ({ closeModal, onGifClick }) => {
	return (
		<Modal onClickOutside={closeModal}>
			<GifSearch
				onGifClick={(gifId: string, searchTerm: string) => {
					onGifClick(gifId, searchTerm);
					closeModal();
				}}
			/>
		</Modal>
	);
};
